"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { CTA } from "../../shared/components/CTA";
import { RiseGamesBanner } from "@/features/rise-games/_components/RiseGamesBanner";

const games = [
  {
    id: "wordle",
    title: "Wordle",
    description: "Test your word-guessing skills with our daily word puzzle",
    href: "/games/wordle",
    comingSoon: false,
  },
  {
    id: "connections",
    title: "Connections",
    description: "Find groups of four words that share something in common",
    href: "/games/connections",
    comingSoon: false,
  },
  {
    id: "crossword",
    title: "Mini Crossword",
    description: "Complete a quick 5x5 crossword puzzle",
    href: "/games/crossword",
    comingSoon: false,
  },
  {
    id: "personality-quiz",
    title: "AI Personality Test",
    description: "Discover your AI personality type and get tool recommendations",
    href: "/games/personality-quiz",
    comingSoon: false,
  },
  {
    id: "pips",
    title: "Pips",
    description: "A game for logic lovers",
    href: "/games/pips",
    comingSoon: false,
  },
];

export function Games() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Hero Section */}
      <div className="flex-1 flex items-center justify-center py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 w-full">
          <RiseGamesBanner />

          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-32"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-8 tracking-tight">
              Nowadays Games
            </h1>
            <p className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Take a break and enjoy our collection of fun games. Perfect for team building or a quick mental refresh!
            </p>

            {/* Call to Action */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="mt-12"
            >
              <Link href="/games/connections">
                <button className="bg-indigo-100 hover:bg-indigo-200 text-indigo-700 text-lg font-semibold py-4 px-10 rounded-full shadow-sm hover:shadow-md transform transition-all duration-300">
                  Play Connections Now
                  <span className="ml-3">→</span>
                </button>
              </Link>
            </motion.div>
          </motion.div>

          {/* Games Grid - Smaller and below */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto"
          >
            {games.map((game, index) => (
              <motion.div
                key={game.id}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.8 + index * 0.1 }}
                className={game.comingSoon ? "opacity-60" : ""}
              >
                {game.comingSoon ? (
                  <div className="relative bg-indigo-50/50 backdrop-blur rounded-xl p-6 border border-indigo-100">
                    <h3 className="text-base font-semibold text-gray-700 mb-2">{game.title}</h3>
                    <p className="text-sm text-gray-500">Coming Soon</p>
                  </div>
                ) : (
                  <Link href={game.href}>
                    <div className="group relative bg-indigo-50/50 backdrop-blur rounded-xl p-6 border border-indigo-100 hover:bg-indigo-100/70 hover:shadow-sm transition-all duration-300 cursor-pointer">
                      <h3 className="text-base font-semibold text-gray-700 mb-2 group-hover:text-black transition-colors">
                        {game.title}
                      </h3>
                      <p className="text-sm text-gray-600 group-hover:text-gray-700 transition-colors">Play Now →</p>
                    </div>
                  </Link>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
      <CTA />
    </div>
  );
}
